export class SearchResultDTO {

    id: string;

    text: string;
    
    available?: boolean;
    
    reason?: string;

}
